import React, { useState, useEffect } from "react";
// import Select from "react-select";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
// import TimeregService from "../../services/timereg.service";
// import RegsugarService from "../../services/regsugar.service";
// import AcademyService from "../../services/academy.service";
import assocService from "../../services/assoc.service";
import authService from "../../services/auth.service";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
// import "./ModalCheckFactoryMember.css";

// Import Form
import { Form, Col, Row, FormControl } from "react-bootstrap";

//Import Loading
import LoadingAlert from "../../components/LoadingAlert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

function ModalCheckFactoryMember(props) {
  const [form, setForm] = useState({});
  const [data, setData] = useState([]);
  // const [assoc, setAssoc] = useState([]);
  const [errors, setErrors] = useState({});
  const [check, setCheck] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disabledbutton, setDisabledbutton] = useState(true);

  const user = authService.getCurrentUser();

  useEffect(() => {
    initialForm();
  }, []);

  const initialForm = () => {
    getData();
    setForm({});
    setErrors({});
  };

  const handleClose = () => {
    getData();
    initialForm();
    props.hidefunc(false);
    setCheck([]);
  };

  const getData = () => {
    assocService
      .getAssocList()
      .then((response) => {
        setData(response.data.data);
        console.log(props);
        setForm({
          ...form,
          ["assoc"]: data,
        });
        setErrors({
          ...errors,
          ["assoc"]: null,
        });
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setErrors(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const checkID = (id) => {
    // console.log(id.length);
    if (id.length != 13) return false;
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += parseFloat(id.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(id.charAt(12))) return false;

    return true;
  };

  // const getAssoc = () => {
  //   if (props.assocdata === null) {
  //     const assoc_id = form.assoc.associd;
  //     assocService.getAssociationById(assoc_id).then((response) => {
  //       console.log(form.assoc.associd);
  //       setAssoc(response.data.data);
  //       // setAssocName(assoc.association_name_th);
  //     });
  //   }
  // };

  const setField = (field, value) => {
    console.log(props.factorydata);
    setCheck([]);
    setDisabledbutton(true);
    if (field.name == "search") {
      // console.log(!checkID(value));
      if (value.length < 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขไม่ครบ" });
      } else if (value.length > 13) {
        setErrors({ ...errors, [field.name]: "กรอกเลขเกิน" });
      } else if (!checkID(value)) {
        setErrors({ ...errors, [field.name]: "เลขบัตรไม่ถูกต้อง" });
      } else {
        setErrors({ ...errors, [field.name]: null });
      }
    }
    setForm({
      ...form,
      [field.name]: value,
    });
    // props.assocdata([{...form.assoc}]);
    // console.log(props.assocdata);
  };
  const findFormErrors = () => {
    const { search, assoc } = form;
    const newErrors = {};

    if (user.user.member_type !== 4) {
      // start errors
      if (!assoc || assoc === "") newErrors.assoc = "กรุณาระบุสมาคม";
    }
    if (!search || search === "") newErrors.search = "กรุณากรอกเลขบัตรประชาชน";

    return newErrors;
  };

  // const handleAddMember = (object) => {
  //   const search = { search: object[0].farmer_idcard };
  //   setForm(search);
  //   RegsugarService.checkFarmer(search)
  //     .then((response) => {
  //       // console.log(response.data.data);
  //       if (response.data.success) {
  //         checkStatusForMember(response.data.data);
  //         setCheck(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       alert(error);
  //       console.log(error);
  //     })
  //     .finally(() => {
  //       console.log(false);
  //       setLoading(false);
  //     });
  // };

  // const handleAssocChange = async (assoc) => {
  //   setErrors({
  //     ...errors,
  //     ["assoc"]: null,
  //   });
  //   if (assoc && assoc != "") {
  //     await getAssoc(assoc).then(() => {
  //       setForm({
  //         ...form,
  //         ["assoc"]: assoc,
  //       });
  //     });
  //   } else {
  //     setAssoc([]);
  //   }
  // };

  const clickAddMember = (e) => {
    e.preventDefault();
    const newform = [{ ...form }];
    props.onClickAdd(form);
    // props.getAssoc(form.assoc);
    console.log(newform);
  };

  const getValidaMember = (idcard, select_assoc) => {
    assocService
      .validateNewMember(idcard, select_assoc)
      .then((response) => {
        console.log(response.data.data);
        if (response.data.success) {
          checkStatusForMember(response.data.data);
          if (response.data.data.length != 0) {
            setCheck(response.data.data);
          } else {
            confirmAlert({
              title: "",
              message: "ไม่มีข้อมูลเกษตรกรในระบบ ต้องการเพิ่มข้อมูลหรือไม่",
              buttons: [
                {
                  label: "ใช่",
                  onClick: () => {
                    // window.location.href = config.hostname + "/staff/farmer";
                    // setShowAddfarmer(true);
                    // props.hidden(false);
                  },
                },
                {
                  label: "ไม่ใช่",
                  onClick: () => false,
                },
              ],
              overlayClassName: "confirm-alert-default",
            });
          }
        } else {
          alert(response.data.message);
        }
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCheck = (e) => {
    e.preventDefault();
    setLoading(true);
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setLoading(false);
    } else {
      // const selected_assoc = user.user.user_assoc
      //   ? user.user.user_assoc
      //   : form.assoc;
      if (user.user.member_type !== 4) {
        // start errors
        getValidaMember(form.search, form.assoc);
      } else {
        getValidaMember(form.search, user.user.user_assoc);
      }
    }
  };

  const checkStatusForMember = (data) => {
    if (data.length != 0) {
      const result = data.filter(
        (a) =>
          a.assoc_status_text === "เสียชีวิต" ||
          a.farmer_status === "เป็นสมาชิก" ||
          a.reg_status_text === "เสียชีวิต"
      );
      setDisabledbutton(result.length > 0 ? true : false);
    } else {
      setDisabledbutton(true);
    }
  };

  const statusFormatter = (cell) => {
    console.log(cell);
    if (
      cell == "เป็นสมาชิก" ||
      cell == "ชาวไร่" ||
      cell == "มีชีวิต" ||
      cell == "ส่งปกติ"
    ) {
      return <p className="text-success">{cell}</p>;
    } else if (cell == "พ้นสภาพ" || cell == "ขาดส่ง") {
      return <p className="text-danger">{cell}</p>;
    } else if (
      cell == "ลาออก" ||
      cell == "เสียชีวิต" ||
      cell == "ไม่มีการส่ง"
    ) {
      return <p className="text-danger">{cell}</p>;
    } else {
      return <p>{cell}</p>;
    }
  };

  const memberFormatter = (cell) => {
    console.log(cell);
    if (cell == "เป็นสมาชิก") {
      return <p className="text-success">{cell}</p>;
    } else {
      return (
        <button
          disabled={disabledbutton}
          className="btn btn-success btn-disable-custom"
          onClick={clickAddMember}
        >
          เพิ่มสมาชิก
        </button>
      );
    }
  };
  const columns = [
    {
      dataField: "farmer_idcard",
      text: "ID",
      hidden: true,
    },
    {
      dataField: "farmer_idcard",
      text: "บัตรประชาชน",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_name",
      text: "ชื่อ - สกุล",
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_card_id",
      text: "รหัสเกษตรกร",
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "reg_status_text",
      text: "ข้อมูลชาวไร่อ้อย",
      formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "farmer_status",
      text: "สถานะ",
      formatter: statusFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        textAlign: "center",
      },
    },
    {
      dataField: "assoc_status_text",
      text: "การเป็นสมาชิก",
      formatter: memberFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        textAlign: "center",
      },
    },
  ];

  return (
    <>
      {loading ? <LoadingAlert /> : ""}
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>ตรวจสอบข้อมูล</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* {user.user.user_assoc ? user.user.user_assoc : form.assoc} */}
            <Form>
              <Row className="search-check">
                {user.user.member_type !== 4 ? (
                  <Col>
                    <Form.Group>
                      {/* <Select options={form.assoc} /> */}
                      {props.factorydata.factoryName}
                      <Form.Select
                        name="factory"
                        value={form.factory}
                        // onChange={(e) => handleAssocChange(e.target.value)}
                        onChange={(e) => setField(e.target, e.target.value)}
                        isInvalid={!!errors.factory}
                        disabled={props.factorydata ? true : false}
                      >
                        <option value="">เลือกสมาคม</option>
                        {data.map((o, index) => {
                          return (
                            <option key={index} value={o.factoryId}>
                              {o.factoryName}
                            </option>
                          );
                        })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.factory}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                ) : (
                  ""
                )}
                <Col>
                  <Form.Group>
                    <FormControl
                      placeholder="บัตรประชาชน"
                      type="number"
                      name="search"
                      value={form.search}
                      onChange={(e) => setField(e.target, e.target.value)}
                      isInvalid={!!errors.search}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.search}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg="4">
                  <Form.Group>
                    <button
                      className="btn btn-primary btn-add-custom"
                      onClick={handleCheck}
                    >
                      ตรวจสอบการเป็นสมาชิก
                    </button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
            {/* {JSON.stringify(props)} */}
          </div>
          <div className="list-regsugar-name" lg="12">
            <BootstrapTable
              keyField="farmer_id"
              data={check}
              columns={columns}
              // width="100%"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* <button className="btn btn-warning" onClick={handleClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            type="submit"
            onClick={handleSubmit}
          >
            Save Changes
          </button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCheckFactoryMember;

ModalCheckFactoryMember.propTypes = {
  show: PropTypes.bool,
  hidefunc: PropTypes.func,
  onClickAdd: PropTypes.func,
  // getAssoc: PropTypes.func,
  factorydata: PropTypes.object,
  // hidden: PropTypes.func,
  // data: PropTypes.array,
  // setdata: PropTypes.func,
  // setShowAddDetail: PropTypes.func,
  // selectFarmerIdcard: PropTypes.func,
  // setFarmerid: PropTypes.func,
};
